import {FETCH_TUITION_BY_ID} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_TUITION_BY_ID:
            return action.payload;
        default:
            return state;
    }
};